import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export const ActiveOrderModel = ({
  open,
  onClose,
  onConfirm,
  title,
  boldText,
  description,
}) => {
  const { t } = useTranslation("active-order-modal");

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "556px",
          mx: "5px",
          borderRadius: 4,
          boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.08)",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          borderBottom: "1px solid #EAEAEA",
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "18px",
            color: "#2F2B3DE5",
            p: 0,
          }}
        >
          {title}
        </DialogTitle>
        <IconButton onClick={onClose}>
          <img src="/cancel_icon.svg" alt="close icon" />
        </IconButton>
      </Box>

      {/* Body */}
      <DialogContent sx={{ p: 3 }}>
        <Typography
          sx={{
            mb: 1,
            fontSize: "16px",
            fontWeight: 500,
            color: "#2F2B3DE5",
          }}
        >
          {boldText}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#2F2B3D99" }}>
          {description}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{ px: 3, pb: 3, pt: 0, justifyContent: "space-between" }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#808390",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: 500,
            color: "white",
            textTransform: "capitalize",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#808399",
              boxShadow: "none",
            },
          }}
        >
          {t("continue_editing")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: "#257C6D",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: 500,
            color: "white",
            textTransform: "capitalize",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#257C6D",
              boxShadow: "none",
            },
          }}
        >
          {t("i_understand_save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
